import {isAzubi, isAusbilder, isTrainer, isFachausbilder} from 'ag-common/tools/roles'

export const DEFAULT_PATH_AUSBILDER = '/uebersicht'
export const DEFAULT_PATH_TRAINER = '/meineazubis'
export const DEFAULT_PATH_AZUBI = '/meineausbildung'
export const DEFAULT_PATH_NO_ROLE = '/login-error'

export function defaultPathForRole(role) {
  if (isAzubi(role)) return DEFAULT_PATH_AZUBI
  if (isAusbilder(role)) return DEFAULT_PATH_AUSBILDER
  if (isTrainer(role)) return DEFAULT_PATH_TRAINER
  if (isFachausbilder(role)) return DEFAULT_PATH_AUSBILDER
  return DEFAULT_PATH_NO_ROLE
}
